import { render } from "./app-modal-attach-tax.vue?vue&type=template&id=6c0b034c"
import script from "./app-modal-attach-tax.vue?vue&type=script&lang=js"
export * from "./app-modal-attach-tax.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-attach-tax.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c0b034c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c0b034c', __exports__)) {
    console.log('reload')
    api.reload('6c0b034c', __exports__)
  }
  
  module.hot.accept("./app-modal-attach-tax.vue?vue&type=template&id=6c0b034c", () => {
    console.log('re-render')
    api.rerender('6c0b034c', render)
  })

}


export default __exports__